// extracted by mini-css-extract-plugin
export default {"sectionLabel":"detail-general-tab_sectionLabel__EJNwF","value":"detail-general-tab_value__0q09g"};